import { render } from "./TheProfessionalDocumentShowModal.vue?vue&type=template&id=83f57990&ts=true"
import script from "./TheProfessionalDocumentShowModal.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalDocumentShowModal.vue?vue&type=script&lang=ts"

import "./TheProfessionalDocumentShowModal.vue?vue&type=style&index=0&id=83f57990&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__